(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileDialogController', ProfileDialogController);

    ProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Profile', 'User', 'SkipperLevelHolder'];

    function ProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Profile, User, SkipperLevelHolder) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query();
        vm.skipperlevelholders = SkipperLevelHolder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profile.id !== null) {
                Profile.update(vm.profile, onSaveSuccess, onSaveError);
            } else {
                Profile.save(vm.profile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:profileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthdate = false;
        vm.datePickerOpenStatus.expelledDate = false;

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.matriculationCertificate = base64Data;
                        profile.matriculationCertificateContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.matriculationDate = false;
        vm.datePickerOpenStatus.idExpirationDate = false;
        vm.datePickerOpenStatus.lastLogin = false;
        vm.datePickerOpenStatus.fullMemberDate = false;
        vm.datePickerOpenStatus.isafDate = false;

        vm.setImage = function ($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.image = base64Data;
                        profile.imageContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
